import React from 'react'
import PropTypes from 'prop-types'

const SkipLink = ({ id, children, className }) => {
  return (
    <a
      href={`#${id}`}
      className={`${className}
        absolute w-2 h-2 z-50
        block overflow-hidden text-ffffff
        focus:h-auto focus:w-auto
      `}
    >
      {children}
    </a>
  )
}

SkipLink.propTypes = {
  id: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
}

SkipLink.defaultProps = {
  id: '#component',
  children: 'Zur Komponente X',
  className: '',
}

export default SkipLink
